module.exports = __webpack_public_path__ + "static/img/web-v3-04.761a9d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/web-v3-04.png
// module id = +UA2
// module chunks = 1